


class DatetimeService {
  constructor() {

  }

  getFirstAndLastDayOfMonth(date) {
    const lastDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    const firstDate = new Date(date.getFullYear(), date.getMonth(), 1);
    if (firstDate && lastDate) {
      return { firstDate, lastDate };
    }
    return null;
  }

  getFirstAndLastDayOfYear(date) {
    const firstDate = new Date(date.getFullYear(), 0, 1);
    const lastDate = new Date(date.getFullYear(), 11, 31);

    if (firstDate && lastDate) {
      return { firstDate, lastDate };
    }
    return null;
  }
}

export default new DatetimeService();
